module.exports = __webpack_public_path__ + "static/media/video-placeholder.f233e617.jpg";